<script>
import { STATUS, DUMMY_SCHEDULE_ITEM } from '@/settings/index'
import Actions from './Actions'

export default {
  components: {
    Actions
  },

  props: {
    item: {
      type: Object,
      default: () => {
        return DUMMY_SCHEDULE_ITEM
      }
    }
  },

  data() {
    return {
      STATUS: STATUS
    }
  },

  mounted() {},

  methods: {
    openDetail: function () {
      this.$store.dispatch('Schedule/toggleDetail', this.item)
    }
  }
}
</script>
